module.exports = __webpack_public_path__ + "static/media/lupabanner_sm3.8937869c.png";